import React, {useEffect,Component} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./LandingPageProjectCards";
import {
  ProjectCards,
  Residential,
  Commercial,
  // Living,
  Interior,
} from "../../data";
import { Tab, Tabs, TabList, TabPanel } from "../Lib/react-tabs/esm/index";
import "../Lib/react-tabs/style/react-tabs.css";
import {Link} from "react-router-dom";
// import Button22 from "../../Tablet/LandingPage";

export default class LandingPageProjectCards extends Component {


    
  render() {
    return (
      <>
        <Tabs>
          <TabList>
            <Tab>
              <div className="lpd-price lpd-overpass-extra-bold-shark-14px">
                ALL
              </div>
            </Tab>
            <Tab>
              <div className="lpd-apartments lpd-typographybodycaption-14-semi-bold">
                RESIDENTIAL
              </div>
            </Tab>
            <Tab>
              <div className="lpd-buildiings lpd-typographybodycaption-14-semi-bold">
                COMMERCIAL
              </div>
            </Tab>
            {/* <Tab>
              <div className="lpd-place lpd-typographybodycaption-14-semi-bold">
                LIVING
              </div>
            </Tab> */}
            <Tab>
              <div className="lpd-living lpd-typographybodycaption-14-semi-bold">
                INTERI0R
              </div>
            </Tab>
          </TabList>
          <TabPanel >
            <div className="lpcv-row">
              {ProjectCards.map((item) => (
                  <div className={`lpcv-column ${item.className}`}>
                     <Link to={`/projectdetails/${item.id}`}>
                    <div className="lpcv-image">
                      <img className="lpd-rectangle-62" src={item.rectangle62} alt="project cards" />
                    </div>
                  
                    <div className="lpcv-text-group">
                      <div className="lpcv-header">{item.text1}</div>
                      <div className="lpcv-para">{item.surname}</div>
                    </div>
                    </Link>
                  </div>
             
              ))}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="lpcv-row">
              {Residential.map((item) => (
                <div className={`lpcv-column ${item.className}`}>
                  <Link to={`/projectdetails/${item.id}`}>
                    <div className="lpcv-image">
                      <img src={item.rectangle62} alt="project cards" />
                    </div>
                    <div className="lpcv-text-group">
                      <div className="lpcv-header">{item.text1}</div>
                      <div className="lpcv-para">{item.surname}</div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="lpcv-row">
              {Commercial.map((item) => (
                <div className={`lpcv-column ${item.className}`}>
                  <div className="lpcv-image">
                    <img src={item.rectangle62} alt="project cards" />
                  </div>
                  <div className="lpcv-text-group">
                    <div className="lpcv-header">{item.text1}</div>
                    <div className="lpcv-para">{item.surname}</div>
                  </div>
                </div>
              ))}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="lpcv-row">
              {Interior.map((item) => (
                <div className={`lpcv-column ${item.className}`}>
                  <Link to={`/projectdetails/${item.id}`}>
                    <div className="lpcv-image">
                      <img src={item.rectangle62} alt="project cards" />
                    </div>
                    <div className="lpcv-text-group">
                      <div className="lpcv-header">{item.text1}</div>
                      <div className="lpcv-para">{item.surname}</div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </TabPanel>
          <Button22>VIEW ALL</Button22>
        </Tabs>
      </>
    );
  }
}

function Button22(props) {
    const { children } = props;
  
    useEffect(() => {
      loadTimelineData(x26013224TimelineData);
    }, []);
  
    return (
      <Link to='/project'>
      <div className="lpt-x26013224 lpt-component lpt-component-wrapper not-ready">
        <div className="lpt-master-button-KTVw70">
          <div className="lpt-button-i2601322451-i3uVbP lpt-valign-text-middle">{children}</div>
        </div>
      </div>
      </Link>
    );
  }
  
  const x26013224TimelineData = [
    {
      initial_state_name: "Property-1=Tertiary",
      root_element: ".x26013224",
      states_flow: {
        "Property-1=Primary": {
          listeners: [],
          overrides: {},
        },
        "Property-1=Secondary": {
          listeners: [],
          overrides: {},
        },
        "Property-1=Tertiary": {
          listeners: [],
          overrides: {},
        },
      },
    },
  ];